import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalOutletAppPermission = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.AppPermission />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalOutletAppPermission = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalOutletAppPermission />
    </Suspense>
  );
};
